<template>
    <div class="workers">
        <router-view class="view"></router-view>
    </div>
</template>

<script>

export default {
    name: 'WorkersPage',
    components: {
    },
    computed: {
    },
}
</script>

<style lang="scss" scoped>
.workers {
    width: 100%;
}

.view {
    width: -webkit-fill-available;
    max-width: 100%;
    padding: 1rem 2rem;
    overflow: auto;
}
</style>